import axios from "axios";
import { toast } from "react-toastify";

const defaultOptions = {
  baseURL: "https://kriechapi.krieshrestaurant.com/api",
  // baseURL: "http://127.0.0.1:8000/api",

  headers: {
    Accept: "application/json",
  },
};

export const axiosInstance = axios.create(defaultOptions);

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});
axiosInstance.interceptors.response.use(null, (error) => {
  if (error.response && error.response.status === 401) {
    // Don't redirect if we're already on the login page
    const isLoginPage = window.location.pathname === "/login";
    
    if (!isLoginPage) {
      toast.error(error.response.data?.message || "Session expired. Please login again.");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userName");
      window.location = "/login";
    }
  }
  return Promise.reject(error);
});
